/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */

/** @module core/modules/object-utils/get-values-array */

/**
 * @description Returns an array containing object own enumerable property values.
 * @param {Object<string,*>} object - Input object.
 * @returns {Array<*>} Values array.
 */
function getValuesArray(object) {
  var output = [];

  for (var i in object) {
    if (!Object.hasOwnProperty.call(object, i)) {
      continue;
    }

    output.push(object[i]);
  }

  return output;
}

export { getValuesArray };